import React from 'react';
import PropTypes from 'prop-types';
import { get, set } from '../Storage';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import { ClassName } from 'mgToolsKit';
import { MGSiteButton } from "mgUiKit";
import IconButton from 'material-ui/IconButton';
import ActionGrade from 'material-ui/svg-icons/action/grade';
import * as Colors from 'material-ui/styles/colors';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'DepositComponent';

var styles = AppSettings.styles;

class Deposit extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            error: false,
            errorMessage: "",
            details: true,
            loading: false
        }
        this.addPreferiti = this.addPreferiti.bind(this);
    }

    componentDidMount() {

    }

    renderPaymentDetails(deposit) {
        /**/
        var costoGratuito = "";
        if (deposit.hasCommission && deposit.commissions.length == 1) {
            var costo = deposit.commissions[0].costAmount;
            costo = parseFloat(costo.replace("€", "").replace(",", ".").trim());
            if (!isNaN(costo) && costo == 0) {
                costoGratuito = <li>Costo: GRATUITO</li>
            }
        }

        if (!deposit.hasInfo && costoGratuito == "") {
            return null;
        }

        return (
            <ul className="paymentDetails">
                {costoGratuito}

                {deposit.info.clearingType != null ?
                    <li className="us-payment-clearingtype">{deposit.info.clearingType}</li>
                    : null}

                {deposit.info.minAmount != null ?
                    <li className="us-payment-minamount">{deposit.info.minAmount}</li>
                    : null}

                {deposit.info.maxAmount != null ?
                    <li className="us-payment-maxamount">{deposit.info.maxAmount}</li>
                    : null}
            </ul>
        );
    }

    renderCommission(deposit) {
        if (!deposit.hasCommission) {
            return null;
        }

        var commissions = deposit.commissions.map(function (commission, i) {
            var key = "com_" + i;
            var externalCost = "";
            if (commission.internalCostPayment) {
                var className = "title-cost logo-" + commission.code;
                externalCost = <li className={className}>
                    <span>{commission.name}</span>
                </li>;
            }
            return (
                <ul key={key} className="userbox-money-commission-cost">
                    {externalCost}
                    <li>Costo: <span>{commission.costAmount}{commission.isPercentage ? "%" : ""}</span> per i depositi da <span>{commission.operationMinAmount}</span> a <span>{commission.operationMaxAmount}</span></li>
                    <li>Commissione: min. <span>{commission.minCommissionAmount == "-" ? "nessuna" : commission.minCommissionAmount}</span>,  max. <span>{commission.maxCommissionAmount == "-" ? "nessuna" : commission.maxCommissionAmount}</span></li>
                </ul>
            );
        });

        return (
            <>
                {commissions}
            </>
        );
    }

    addPreferiti() {
        if (!AppSettings.usersettings) {
            return;
        }
        this.setState({
            loading: true
        });
        var code = this.props.deposit.code;
        try {
            var index = AppSettings['userSettings'].preferredDeposit.indexOf(code);
            if (!Array.isArray(AppSettings['userSettings'].preferredDeposit)) {
                AppSettings['userSettings'].preferredDeposit = [];
            }
            if (index == -1) {
                AppSettings['userSettings'].preferredDeposit.push(code);
            }
            else {
                AppSettings['userSettings'].preferredDeposit.splice(index, 1);
            }
            var url = AppSettings['env'].urlUserBoxSetUserSettings;
            var post = { setting: { group: "UserBox", value: JSON.stringify(AppSettings['userSettings']) }, sessionToken: "" };
            axios.post(url, post)
                .then(({ data, status, statusText }) => {
                    if (data) {

                        set(AppSettings);
                        this.props.reload();
                    }
                    else {

                    }
                    this.setState({
                        loading: false
                    });
                })
                .catch(function (error) {
                    this.setState({
                        loading: false
                    });
                }.bind(this));
        }
        catch (e) { }
    }
    /*
    openLinkPopup(e,url){
        if(AppSettings.openlinkpopup && AppSettings.device != "mobile"){
            var width = "800";
            var height = "640";
            var left = (screen.width / 2) - (width / 2);
            var top = (screen.height / 2) - (height / 2);
            var options = 'width=' + width +',height=' + height +',menubar=no,resizable=no,toolbar=no,left=' + left +',top=' + top +'';
            window.open(url, "payment", options); 
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
        }
    }*/

    renderOtherPayment(deposit) {

        if (deposit.otherPayment == null || deposit.otherPayment == undefined || deposit.otherPayment.length == 0) {
            return "";
        }

        var listOtherdeposit = [];
        deposit.otherPayment.map(function (otherPayment, i) {
            var attributes = {
                href: "/Deposit/" + deposit.code + ".aspx"
            };

            var key = otherPayment.code;

            // if(otherPayment.href != "" && otherPayment.href != undefined){
            //     attributes['href'] = otherPayment.href;
            // }
            if (otherPayment.hrefTarget != "" && otherPayment.hrefTarget != undefined) {
                attributes['target'] = otherPayment.hrefTarget;
            }

            if (otherPayment.image != "" && otherPayment.image != undefined) {
                attributes['style'] = {
                    "backgroundImage": "url(" + otherPayment.image + ")"
                };
            }

            attributes['onClick'] = (e) => {
                this.context.openLinkPopup(e, attributes['href']);
            }

            listOtherdeposit.push(
                <li className={otherPayment.code} key={otherPayment.code}>
                    <a {...attributes} >
                        {otherPayment.name}
                    </a>
                </li>);
        }.bind(this));
        return (
            <ul className="other-payment">
                {listOtherdeposit}
            </ul>
        );
    }

    render() {
        var deposit = this.props.deposit;
        var key = deposit.code;
        var _className = new Array();
        _className.push("userbox-money-tool");
        _className.push("ub-" + deposit.code)
        var details = deposit.details;

        var toolTip = "";
        if (AppSettings['userSettings'].preferredDeposit.indexOf(deposit.code) != -1) {
            var iconStyle = { color: AppSettings.theme.primarycolor };
            //var toolTip = "Rimuovi dai preferiti";
        }
        else {
            var iconStyle = { color: Colors.grey400 };
            //var toolTip = "Imposta come ricarica preferita";
        }
        var depositUrl = deposit.url;

        var clickEvent = (e) => {
            this.context.openLinkPopup(e, depositUrl);
        }
        return (

            <li key={key} className={ClassName(_className)}>
                <h4>
                    <span className="userbox-money-tool-logo"></span>
                    <span className="userbox-money-tool-name">{deposit.title}</span>
                    {AppSettings.usersettings ?
                        <IconButton tooltip={toolTip}
                            touch={true}
                            iconStyle={iconStyle} tooltipPosition="top-left"
                            tooltipStyles={styles.fontSize11}
                            onClick={this.addPreferiti}
                        >
                            {!this.state.loading ?
                                <ActionGrade />
                                : <CircularProgress thickness={2} size={20} style={styles.loadingIcon} />}
                        </IconButton>
                        : null}
                </h4>
                {this.renderOtherPayment(deposit)}
                <p className="userbox-money-tool-description">
                    <span dangerouslySetInnerHTML={{ __html: deposit.description }} />
                </p>

                <MGSiteButton
                    title="Ricarica"
                    //href={depositUrl}            
                    class=""
                    label="Ricarica"
                    disabled={false}
                    primary={true}
                    isButton={true}
                    fullWidth={true}
                    actionFunc={clickEvent}
                />

                {deposit.hasCommission || deposit.hasInfo ?
                    <div className="wrap-info-dettagli">
                        <input type="checkbox" id={"info-dettagli-" + key} className="toggle-info" />
                        <label htmlFor={"info-dettagli-" + key} className="toggle-label">
                            Informazioni e costi
                        </label>
                        <div className="info-dettagli-aperti">
                            {this.renderPaymentDetails(deposit)}
                            {this.renderCommission(deposit)}
                        </div>
                    </div>
                    : null}
            </li>
        )
    }
}
Deposit.displayName = componentName;

// PropTypes validation
Deposit.propTypes = {};

// default props
Deposit.defaultProps = {};

Deposit.contextTypes = {
    openLinkPopup: PropTypes.func
}

export default Deposit;